import type { CustomDimensionsRepository } from '../types';
import {
  getGaCustomDimensions,
  getGaCustomParams,
  updateCustomParam,
  updateCustomParams,
} from './dimensions';

export const createCustomDimensionsRepository =
  (): CustomDimensionsRepository => {
    return {
      getAllParams: getGaCustomParams,
      /** @deprecated Use getAllParams instead */
      getAll: getGaCustomDimensions,
      update: updateCustomParams,
      set: updateCustomParam,
    };
  };
